import React from "react";
import Image from "next/image";

type ServicesCRMCardProps = {
  backgroundImage: string;
  title: string;
  description: string;
  isOpen?: boolean;
};

const ServicesCRMCard: React.FC<ServicesCRMCardProps> = ({
  title,
  description,
  isOpen,
  backgroundImage,
}) => {
  return (
    <div className="relative overflow-hidden flex justify-start flex-row group pravin-animation w-fit">
      <div className="shadow-[0px_12.68px_57.07px_-7.93px_#001A2D3D] overflow-hidden relative group h-[70vh] min-w-[45vh] max-w-[45vh]">
        {backgroundImage ? (
          <Image
            src={backgroundImage}
            alt="industry bg"
            width={810}
            height={600}
            quality={100}
            className="w-full h-full max-h-full object-cover object-center transition-all duration-300 scale-100 ease-in-out group-hover:scale-[1.1] group-focus-within:scale-100"
          />
        ) : (
          <div className="w-full h-full max-h-full bg-[#E6EAF0]" />
        )}
        <span className="bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,#000000_100%)] absolute top-auto bottom-0 right-0 w-full h-full"></span>

        <div className="absolute bottom-0 left-0 py-[26px] max-w-[680px] px-5">
          <h3 className="text-heading-5 font-bold text-primary-text-white mb-[12px]">
            {title}
          </h3>

          <a
            // href="#!"   // there won't be any link as per discussion with Praveen bhai and Samir bhai
            className="text-primary-text-white py-[16px_14px] flex items-center"
          >
            More Info
            <Image
              height={16}
              width={16}
              src="/images/crm/info-circle.png"
              alt=""
              className="ms-2 mt-0.5 min-w-[16] max-h-[16px]"
            />
            <div
              className={`${isOpen ? "opacity-100" : "opacity-0"} w-6 h-7 bg-white [clip-path:polygon(0_50%,100%_0,100%_100%)] z-40 absolute -right-0.5 sm:rotate-0 rotate-150 sm:bottom-[40px] bottom-[-15px] transition-all duration-300 group-hover:delay-75 delay-300 ease-linear`}
            ></div>
          </a>
        </div>
      </div>

      <div className="flex relative w-[60vh] min-w-[60vh] max-w-[60vh] justify-end xl:ml-[0] flex-col bg-white h-[70vh] p-[24px] pravin-animation-show">
        <p className="font-semibold text-primary-text mt-2 text-[clamp(14px,1.2vw,20px)]">
          {description}
        </p>
      </div>
    </div>
  );
};
export default ServicesCRMCard;
